var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchDiconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 30.282,
    viewBox: "0 0 27 30.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1801",
    "data-name": "Group 1801",
    transform: "translate(-354.998 -487.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_7465",
    "data-name": "Path 7465",
    transform: "translate(354.998 487.925)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0A13.5,13.5,0,1,1,0,13.5,13.5,13.5,0,0,1,13.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.50000476837158 1.999994277954102 C 10.42824554443359 1.999994277954102 7.540334701538086 3.196205139160156 5.368265151977539 5.368265151977539 C 3.196205139160156 7.540334701538086 1.999994277954102 10.42824554443359 1.999994277954102 13.50000476837158 C 1.999994277954102 16.5717658996582 3.196205139160156 19.45967483520508 5.368265151977539 21.63173484802246 C 7.540334701538086 23.80379486083984 10.4282341003418 25.00000381469727 13.50000476837158 25.00000381469727 C 16.5717658996582 25.00000381469727 19.45967483520508 23.80379486083984 21.63173484802246 21.63173484802246 C 23.80379486083984 19.45967483520508 25.00000381469727 16.5717658996582 25.00000381469727 13.50000476837158 C 25.00000381469727 10.4282341003418 23.80379486083984 7.540334701538086 21.63173484802246 5.368265151977539 C 19.45967483520508 3.196205139160156 16.5717658996582 1.999994277954102 13.50000476837158 1.999994277954102 M 13.50000476837158 -5.7220458984375e-06 C 20.95585441589355 -5.7220458984375e-06 27.00000381469727 6.044155120849609 27.00000381469727 13.50000476837158 C 27.00000381469727 20.95585441589355 20.95585441589355 27.00000381469727 13.50000476837158 27.00000381469727 C 6.044155120849609 27.00000381469727 -5.7220458984375e-06 20.95585441589355 -5.7220458984375e-06 13.50000476837158 C -5.7220458984375e-06 6.044155120849609 6.044155120849609 -5.7220458984375e-06 13.50000476837158 -5.7220458984375e-06 Z",
    stroke: "none",
    fill: "#1d3378"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8073",
    "data-name": "Path 8073",
    d: "M361.775,499.335l8.521,5.193-4.974,3.145V496.043l4.974,3.145-8.521,4.827",
    transform: "translate(2.462 -0.678)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2230",
    "data-name": "Group 2230",
    transform: "translate(-6.452 -8.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231",
    transform: "translate(362.354 509.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8066",
    "data-name": "Path 8066",
    d: "M14.206,14.295l4.1,4.1",
    transform: "translate(-3.11 -3.131)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8067",
    "data-name": "Path 8067",
    d: "M0,0,4.1,4.1",
    transform: "translate(15.191 11.164) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2230-2",
    "data-name": "Group 2230",
    transform: "translate(362.354 509.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8066-2",
    "data-name": "Path 8066",
    d: "M14.206,14.295l4.1,4.1",
    transform: "translate(-3.11 -3.131)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8067-2",
    "data-name": "Path 8067",
    d: "M0,0,4.1,4.1",
    transform: "translate(15.191 11.164) rotate(90)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchDiconnected);
export default __webpack_public_path__ + "static/media/watch_diconnected.231ee34b3ad7557ebbb8886a16352b81.svg";
export { ForwardRef as ReactComponent };